/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Copylink1Inputs */

const en_btn_copylink1 = /** @type {(inputs: Btn_Copylink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy Link`)
};

/**
* | output |
* | --- |
* | "Copy Link" |
*
* @param {Btn_Copylink1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_copylink1 = /** @type {((inputs?: Btn_Copylink1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Copylink1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_copylink1(inputs)
});
export { btn_copylink1 as "btn_copyLink" }